import { useSelector } from 'react-redux'
import cnames from 'classnames'

const BUTTON_ACTIVE_CLASS = 'active btn btn-blue-dark text-white'
const BUTTON_BASE_CLASS = 'btn btn-outline-dark-blue fw-bold text-start'

export const useAccommodationOptionsClasses = isGroup => {
  const isDayUse = useSelector(state => state.search.accommodation === 'daily')
  const buttonBaseClass = cnames(BUTTON_BASE_CLASS, { 'py-2 px-5': isGroup, 'mb-3 p-2': !isGroup })
  const btnDailyClasses = cnames(buttonBaseClass, { [BUTTON_ACTIVE_CLASS]: isGroup && isDayUse })
  const btnNightly = cnames(buttonBaseClass, { [BUTTON_ACTIVE_CLASS]: isGroup && !isDayUse })
  const buttonsContainer = cnames({
    'btn-group': isGroup,
    'd-flex flex-column': !isGroup,
  })

  return { btnDailyClasses, btnNightly, buttonsContainer }
}
